import { StripeElementsOptionsMode } from "@stripe/stripe-js";
import { useMemo } from "react";
import { useStripeOptions } from "./useStripeOptions";

export function useStripeSetupModeOptions(): StripeElementsOptionsMode {
    const defaultStripeOptions = useStripeOptions();

    return useMemo(
        () => ({
            ...defaultStripeOptions,
            mode: "setup",
            setupFutureUsage: "off_session",
            currency: "usd",
        }),
        [defaultStripeOptions],
    );
}
